export abstract class QuoteToggleConstants {
    static DELAYED_QUOTE = 'D';
    static REALTIME_QUOTE = 'R';
    static PRIOR_CLOSE = 'P';
    static TOGGLE_ACTION = 'toggle';
    static REFRESH_ACTION = 'refresh';
    static TOGGLE_ON_AGREE = 'toggleOnAgree';
    static TIME_ZONE: string = 'America/New_York';
    static DATE_FORMAT: string = 'MM/dd/YYYY';
    static DATE_SHORT_FORMAT: string = 'MMM dd, y';
    static SHORTTIME_FORMAT: string = 'LT';
    static QUOTE_TYPE: string = 'quoteType'; // key in the sessionStorage
    static SIGNED_EXCHANGE_AGREEMENT: string = 'signedExchangeAgreement'; // key in the sessionStorage
}
